<template>
  <section class="section-container" v-if="!is_supplier">
    <div class="content-wrapper">
      <div class="content-heading" v-if="blacklist.id">
        {{ $t('blacklist.edit') }}
      </div>
      <div class="content-heading" v-else>
        {{ $t('blacklist.add') }}
      </div>
      <div class="row">
        <div class="col-xl-8">
          <div class="card card-default">
            <div class="card-body">
              <form @submit.prevent="save" class="form-modal form-blacklist">

                <div class="form-group">
                  <label for="code">{{ $t('blacklist.name') }} *</label>
                  <multiselect
                    :searchable="true"
                    :options="codes"
                    id="code"
                    label="code_with_name"
                    :placeholder="$t('blacklist.select-code')"
                    track-by="id"
                    :show-no-results="false"
                    @search-change="suggest_code"
                    @select="select_code"
                    v-model="blacklist.part">
                    <template slot="noOptions">{{ $t('global.no-options') }}</template>
                  </multiselect>
                  <ul class="parsley-errors-list filled" v-if="errors.part">
                    <li class="parsley-required">{{ errors.part[0] }}</li>
                  </ul>
                </div>

                <div class="form-group">
                  <label>{{ $t('blacklist.name') }}: </label>
                  <span><b>{{ name }}</b></span>
                </div>

                <div class="form-group">
                  <label for="producers">{{ $t('blacklist.producer') }} *</label>
                  <multiselect
                    :clear-on-select="false"
                    :close-on-select="false"
                    :hide-selected="true"
                    :internal-search="false"
                    :limit="50"
                    :limit-text="limitText"
                    :loading="isLoading"
                    :max-height="800"
                    :multiple="true"
                    :options="options"
                    :options-limit="300"
                    :searchable="true"
                    :show-no-results="false"
                    @search-change="getProducers"
                    id="producers"
                    label="name"
                    open-direction="bottom"
                    :placeholder="$t('blacklist.search-and-choose')"
                    track-by="id"
                    v-model="producers">
                    <template slot="tag" slot-scope="{ option, remove }">
                      <span class="custom__tag">
                        <span>{{ option.name }}</span>
                          <a @click="remove(option)" class="search-choice-close"></a>
                      </span>
                    </template>
                    <template slot="noOptions">{{ $t('global.no-options') }}</template>
                    <template slot="clear" slot-scope="props">
                      <div
                        @mousedown.prevent.stop="clearAll(props.search)"
                        class="multiselect__clear"
                        v-if="producers.length"
                      ></div>
                    </template>
                    <span slot="noResult">{{ $t('blacklist.message-no-elements') }}</span>
                  </multiselect>
                  <ul class="parsley-errors-list filled" v-if="errors.producers">
                    <li class="parsley-required">{{ errors.producers[0] }}</li>
                  </ul>
                </div>

                <div class="form-group">
                  <label class="text-bold" > {{ $t('lblacklist.comment-title') }} *</label>
                  <textarea
                    v-model="blacklist_comment.content"
                    class="form-control"
                    :class="{'parsley-error': errors.blacklist_comment}"
                    :placeholder="$t('lblacklist.add-comment')"
                    rows="2"
                    type="text">
                  </textarea>
                  <ul class="parsley-errors-list filled" v-if="errors.blacklist_comment">
                    <li class="parsley-required">{{ errors.blacklist_comment[0] }}</li>
                  </ul>
                </div>

                <div class="row pb-3">
                  <div class="col-md-6">
                    <div class="checkbox c-checkbox">
                      <label for="is_active">
                        <input
                          v-model="blacklist.is_active"
                          :class="{'parsley-error': errors.is_active}"
                          class="form-control"
                          type="checkbox"
                          id="is_active">
                        <span class="fa fa-check"></span> {{ $t('blacklist.active') }}
                      </label>
                    </div>
                  </div>

                  <div class="col-md-6" v-if="!this.blacklist.id">
                    <more/>
                  </div>

                </div>
                <buttons url="blacklists"/>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import api from '@/api'
import Buttons from '@/components/Buttons.vue'
import message from '@/message'
import More from '@/components/More.vue'
import Multiselect from 'vue-multiselect'
import {parseApiError} from '@/utils'

const getData = (id, next) => {
  if (id) {
    Promise.all([api.get(`/black_lists/${id}/`)])
      .then(([blacklist]) => {
        blacklist.data.part = {
          'id': blacklist.data.part,
          'code': blacklist.data.part_code,
          'code_with_name': blacklist.data.part_code + ' | ' + blacklist.data.part_name
        }

        next({
          name: blacklist.data.part_name,
          blacklist: blacklist.data,
          producers: blacklist.data.producers_options,
          prev_producers: blacklist.data.producers_options,
          prev_is_active: blacklist.data.is_active,
          prev_part_id: blacklist.data.part.id
        })
      })
  } else {
    next({
      blacklist: {
        part: null,
        producers: [],
        is_active: true
      }
    })
  }
}

export default {
  components: {
    buttons: Buttons,
    more: More,
    Multiselect
  },
  data () {
    return {
      codes: [],
      name: '',
      blacklist: {},
      producers: [],
      options: [],
      more: null,
      isLoading: false,
      errors: {},
      blacklist_comment: {content: ''},
      prev_producers: [],
      prev_part_id: null,
      prev_is_active: null

    }
  },
  mounted () {
    this.$parent.menu = 'setup'
    this.$parent.submenu = 'blacklists'
    this.$i18n.locale = this.$store.getters.language
  },
  computed: {
    is_supplier () {
      return this.$store.getters.user_group === 'Supplier'
    }
  },
  methods: {
    select_code (code) {
      this.name = code.name
    },
    suggest_code (q) {
      api.get('/parts/?is_active=true&page_size=100', {
        params: {
          code__icontains: q
        }
      })
        .then(r => {
          let codes = []
          for (var num in r.data.results) {
            if (r.data.results[num].is_black_listed === false) {
              let resp = r.data.results[num]
              resp['code_with_name'] = resp.code + ' | ' + resp.name
              codes.push(resp)
            }
          }
          this.codes = codes
        })
    },
    save () {
      this.errors = {}

      let producers = []
      for (var num in this.producers) {
        producers.push(this.producers[num].id)
      }

      let blackListValid = true
      if (producers.length === 0) {
        this.errors['producers'] = [this.$i18n.t('blacklist.here-is-no-single-item-in-producers-list')]
        blackListValid = false
      }

      if (!this.blacklist.part) {
        this.errors['part'] = [this.$i18n.t('blacklist.you-need-to-choose-at-least-one-part')]
        blackListValid = false
      }

      if (this.blacklist_comment.content.trim().length === 0) {
        this.errors['blacklist_comment'] = [this.$i18n.t('blacklist.comment-cant-contain-just-spaces')]
        blackListValid = false
      }

      if (!blackListValid) {
        return
      }

      let prevProducers = []
      for (var numPrev in this.prev_producers) {
        prevProducers.push(this.prev_producers[numPrev].id)
      }

      let difference = prevProducers.filter(x => !producers.includes(x))
        .concat(producers.filter(x => !prevProducers.includes(x)))

      if (difference.length === 0 &&
        (this.blacklist.is_active === this.prev_is_active) &&
        (this.prev_part_id === this.blacklist.part.id)) {
        this.errors['producers'] = [this.$i18n.t('blacklist.here-is-no-actual-change-in-producers-list')]
        return
      }

      let data = {
        id: this.blacklist.id,
        part: this.blacklist.part ? this.blacklist.part.id : null,
        producers: producers,
        is_active: this.blacklist.is_active,
        comment: this.blacklist_comment.content
      }

      if (this.blacklist.id) {
        api.patch(`/black_lists/${this.blacklist.id}/`, data)
          .then(() => {
            message.success('Blacklist changed')
            this.$router.push({name: 'blacklists'})
          })
          .catch(error => {
            let errors = parseApiError(error, this.$i18n)
            if (error.response && error.response.status === 400) {
              this.errors = errors
            } else {
              message.error(errors)
            }
          })
      } else {
        api.post('/black_lists/', data)
          .then(() => {
            message.success('Blacklist added')
            if (this.more) {
              this.blacklist = {
                part: null,
                producers: [],
                is_active: true
              }
              this.name = ''
              this.producers = []
              this.$router.push({name: 'blacklist_add'})
            } else {
              this.$router.push({name: 'blacklists'})
            }
          })
          .catch(error => {
            let errors = parseApiError(error, this.$i18n)
            if (error.response && error.response.status === 400) {
              this.errors = errors
            } else {
              message.error(errors)
            }
          })
      }
    },
    limitText (count) {
      return `and ${count} other producers`
    },
    getProducers (query) {
      this.isLoading = true
      api.get('/producers/?is_active=true', {
        params: {
          search: query
        }
      })
        .then(r => {
          this.options = r.data.results
          this.isLoading = false
        })
    },
    clearAll () {
      this.producers = []
    }
  },
  beforeRouteEnter (to, from, next) {
    getData(to.params.id, data => {
      next(vm => {
        Object.assign(vm.$data, data)
      })
    })
  },
  beforeRouteUpdate (to, from, next) {
    getData(to.params.id, data => {
      Object.assign(this.$data, data)
      next()
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Blacklist.vue